import React from 'react';
import { CMSContentPage } from '../components/CMSContentPage';
import { cmsApi } from '../services/cmsApi';

export const PrivacyPolicy: React.FC = () => {
  return <CMSContentPage fetchContent={cmsApi.getPrivacyPolicy} />;
};